import React, { useEffect, useState } from "react";
import { Card, Spinner, Alert, Form, Row, Col, Table } from "react-bootstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Base_URL } from "../url";
import { useLocation } from "react-router-dom";
const DocumentInfoScreen = () => {
  const { docno } = useParams();
const location = useLocation();
const doc=location.state?.docno;
const type=location.state?.documentType;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchDetails();
  }, [docno]);

  const fetchDetails = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${Base_URL}/DocumentPostings/GetAcitDetailsFromAchd/${docno}`
      );
      setData(res.data);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch document info");
      setLoading(false);
    }
  };

  const header = data.length > 0 ? data[0] : null;
  let hasItemName=false;
  let hasDirectorName=false;
  let hasPropertyName=false;
  let hasbrbdHead2=false;
  let totals={ debit: 0, credit: 0 };
  let amount=0;
  if(data.length>0){
hasItemName = data?.some(doc => doc?.itemName && doc?.itemName.trim() !== "");
hasDirectorName = data?.some(doc => doc?.directorName && doc?.directorName.trim() !== "");
hasPropertyName = data?.some(doc => doc?.propertyName && doc?.propertyName.trim() !== "");
hasbrbdHead2 = data?.some(doc => doc?.brbdHead2 && doc?.brbdHead2.trim() !== "");
 totals = data.reduce(
  (acc, item) => {
    amount = parseFloat(item.amount) || 0;

    if (item.debitcreditDesc === "Debit") {
      acc.debit += amount;
    } else if (item.debitcreditDesc === "Credit") {
      acc.credit += amount;
    }

    return acc;
  },
  { debit: 0, credit: 0 }
);



}
const difference = totals.debit - totals.credit;
  return (
    <div className="container mt-4">
      <Card className="shadow-sm">
        <Card.Body>
          <h4 className="mb-3"></h4>

          {/* 🔄 Loading */}
          {loading && (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          )}

          {/* ❌ Error */}
          {error && <Alert variant="danger">{error}</Alert>}

          {/* ✅ Data */}
          {!loading && !error && header && (
            <>
              {/* 🔹 HEADER SECTION */}
              <Card className="mb-3 p-3 border">
                <h5 className="mb-3">Document Header</h5>
                <h6 className="mb-3">Reference No : {doc}</h6>
                <Form>
                  <Row>
                  <Col md={6}>
                      <Form.Label>Organisation</Form.Label>
                      <Form.Control
                        value={header.organisationName}
                        readOnly
                      />
                    </Col>
                     <Col md={6}>
                      <Form.Label>Company</Form.Label>
                      <Form.Control value={header.docccDesc} readOnly />
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col md={3}>
                      <Form.Label>Doc No</Form.Label>
                      <Form.Control value={header.docno} readOnly />
                    </Col>
                   
                    <Col md={3}>
                      <Form.Label>Document Type</Form.Label>
                      <Form.Control value={type} readOnly />
                    </Col>

                    <Col md={3}>
                      <Form.Label>FY</Form.Label>
                      <Form.Control value={header.docfy} readOnly />
                    </Col>

                    <Col md={3}>
                      <Form.Label>Month</Form.Label>
                      <Form.Control value={header.docfmDesc} readOnly />
                    </Col>

                  

                   
                  </Row>

                  <Row>
                      <Col md={3}>
                      <Form.Label>Posting Date</Form.Label>
                      <Form.Control
                        value={
                          header.postingDate
                            ? new Date(header.postingDate).toLocaleDateString()
                            : ""
                        }
                        readOnly
                      />
                    </Col>
                   {header.customerName&&(
                      <Col md={3}>
                      <Form.Label>Customer Name</Form.Label>
                      <Form.Control
                        value={
                          header.customerName
                        }
                        readOnly
                      />
                    </Col>
                   )}
                    {header.salesInvoiceNo&&(
                      <Col md={3}>
                      <Form.Label>Sales Invoice No</Form.Label>
                      <Form.Control
                        value={
                          header.salesInvoiceNo
                        }
                        readOnly
                      />
                    </Col>
                   )}

                    

                  </Row>
                </Form>
              </Card>

              {/* 🔹 LINE ITEMS */}
              <Row className="mb-3">
  <Col md={4}>
    <Card className="p-2 text-center bg-light">
      <strong>Total Debit</strong>
      <div>{totals.debit.toFixed(2)}</div>
    </Card>
  </Col>

  <Col md={4}>
    <Card className="p-2 text-center bg-light">
      <strong>Total Credit</strong>
      <div>{totals.credit.toFixed(2)}</div>
    </Card>
  </Col>

  <Col md={4}>
    <Card className="p-2 text-center bg-light">
      <strong>Difference</strong>
      <div
        style={{
          color: difference === 0 ? "green" : "red",
          fontWeight: "bold",
        }}
      >
        {difference.toFixed(2)}
      </div>
    </Card>
  </Col>
</Row>
              <Card className="p-3 border">
                <h5 className="mb-3">Line Items</h5>

                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Posting Key</th>
                      <th>GL</th>
                      <th>Transaction</th>
                      <th>Account Type</th>
                      <th>Dr/Cr</th>
                       {hasItemName && <th>Item Name</th>}
                       {hasbrbdHead2 && <th>Link</th>}
                       {hasDirectorName && <th>Director Name</th>}
                       {hasPropertyName && <th>Property Name</th>}
                       
                      <th>Document Amount</th>
                      <th>Document Currency</th>
                      
                    </tr>
                  </thead>

                  <tbody>
                    {data.map((doc, index) => (
                      <tr key={index}>
                        <td>{doc.docitem}</td>
                        <td>{doc.postingkeyDesc}</td>
                        <td>{doc.glDesc}</td>
                        <td>{doc.transactionCodeDesc}</td>
                        <td>{doc.accountTypeDesc}</td>
                        
                        <td>{doc.debitcreditDesc}</td>
                         {hasItemName && <td>{doc.itemName}</td>}
                         {hasbrbdHead2 && <td>{doc.brbdHead2}</td>}
                          {hasDirectorName && <td>{doc.directorName}</td>}
                            {hasPropertyName && <td>{doc.propertyName}</td>}
                              

                        <td>{doc.amount}</td>
                        <td>{doc.currencycode}</td>
                      
                        
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card>
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default DocumentInfoScreen;